import _difference from 'lodash/difference';

export default (privileges, statePrivileges) =>
  privileges.length === 0 || _difference(privileges, statePrivileges).length === 0;
